var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 6,
  viewBox: "0 0 28 6",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.2903 0H2.70968C1.21935 0 0 1.21935 0 2.70968C0 4.2 1.21935 5.41935 2.70968 5.41935H25.2903C26.7806 5.41935 28 4.2 28 2.70968C28 1.21935 26.7806 0 25.2903 0Z",
  fill: "#FF583D"
})));
export default __webpack_public_path__ + "static/media/Minus.d0505d72.svg";
export { SvgComponent as ReactComponent };